import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import CandidateProfileDetails from '../../modules/profile/components/CandidateProfileDetails';

const CandidateProfileDetailPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>CreateCandidateForm.MyProfile')} />
      <ContentTemplate type="full">
        <CandidateProfileDetails />
      </ContentTemplate>
    </>
  );
};

export default CandidateProfileDetailPage;
